module.exports = __webpack_public_path__ + "img/ic_back.a8b6586c.svg";